import { render, staticRenderFns } from "./main.vue?vue&type=template&id=5a4efc9c&scoped=true&"
import script from "./main.vue?vue&type=script&lang=js&"
export * from "./main.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4efc9c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/data/websites/erp-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a4efc9c')) {
      api.createRecord('5a4efc9c', component.options)
    } else {
      api.reload('5a4efc9c', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=5a4efc9c&scoped=true&", function () {
      api.rerender('5a4efc9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/SupplierPicker/main.vue"
export default component.exports